import { lazy } from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import DigitalErrorBoundary from '../components/ErrorBoundary/DigitalErrorBoundary';
import { DIGITAL_ACCOUNT_ROUTES } from '../constants/routes';
import ContainerLayout from '../pages/digital-account/layout/container.layout';
import StepsLayout from '../pages/digital-account/layout/steps.layout';
import DocsSign from '../pages/digital-account/ui/print-forms/page';
import VideoCall from '../pages/digital-account/ui/video-call/page';

const RequestAccepted = lazy(
  () => import('../pages/digital-account/ui/video-call/request-accepted')
);
const IdentifyFailed = lazy(() => import('../pages/digital-account/ui/video-call/identfy-failed'));

const UnsupportedFileError = lazy(
  () => import('../pages/digital-account/ui/aggreement-sign/unsuported-file-error')
);

const InsufficientFileError = lazy(
  () => import('../pages/digital-account/ui/aggreement-sign/insufficient_file-error')
);

// Pages
const ConsentLetter = lazy(() => import('../pages/digital-account/ui/aggreement-sign/page'));
const SelectAccounts = lazy(() => import('../pages/digital-account/ui/currency/page'));
const CompanyInfo = lazy(() => import('../pages/digital-account/ui/company-info/page'));
const ShareHolders = lazy(() => import('../pages/digital-account/ui/share-holders/page'));

const BusinessRequest = lazy(() => import('../pages/digital-account/ui/business-request/page'));

const ExistingCustomerProccessCompleted = lazy(
  () => import('../pages/digital-account/ui/existing-customer/completed')
);

const AmlCheckWaiting = lazy(
  () => import('../pages/digital-account/ui/process-status/aml-check-waiting')
);

const digital_routes: RouteObject[] = [
  {
    path: `/:lang/${DIGITAL_ACCOUNT_ROUTES.base}`,
    element: (
      <ContainerLayout>
        <DigitalErrorBoundary>
          <Outlet />
        </DigitalErrorBoundary>
      </ContainerLayout>
    ),
    children: [
      {
        path: DIGITAL_ACCOUNT_ROUTES.consent,
        element: <ConsentLetter />, // set static width
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['request-accepted'],
        element: <RequestAccepted />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['existing-onboarding-succeed'],
        element: <ExistingCustomerProccessCompleted />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['identify-failed'],
        element: <IdentifyFailed />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['unsupported-file-error'],
        element: <UnsupportedFileError />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['insufficient-file-error'],
        element: <InsufficientFileError />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES['aml-check-waiting'],
        element: <AmlCheckWaiting />,
      },
      {
        path: DIGITAL_ACCOUNT_ROUTES.progress,
        element: (
          <StepsLayout>
            <Outlet />
          </StepsLayout>
        ),
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={`${DIGITAL_ACCOUNT_ROUTES.base}/${DIGITAL_ACCOUNT_ROUTES.progress}/${DIGITAL_ACCOUNT_ROUTES.currency}`}
              />
            ),
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES.currency,
            element: <SelectAccounts />,
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES['company-info'],
            element: <CompanyInfo />,
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES['shareholders'],
            element: <ShareHolders />,
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES['business-request'],
            element: <BusinessRequest />,
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES['print-forms'],
            element: <DocsSign />,
          },
          {
            path: DIGITAL_ACCOUNT_ROUTES['videocall'],
            element: <VideoCall />,
          },
        ],
      },
    ],
  },
];

export default digital_routes;
